import { Box, Typography, useBreakpoint } from "@avenue-8/sidekick-ui";
import { MAX_WIDGETS_FIND_MAP_LISTINGS_ITEMS } from "@cma/shared/queries/useWidgetsFindMapListings";
import styled from "@emotion/styled";
import { textFormatter } from "@shared/utils/text-formatter";

const Container = styled(Box)`
  position: absolute;
  text-align: center;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  z-index: 1;
  background: ${(p) => p.theme.colors.background}cf;
`;

export const ResultsLimitInfo = ({ totalItems }: { totalItems: number }) => {
  const isLaptopDown = useBreakpoint("laptop");

  if (totalItems <= MAX_WIDGETS_FIND_MAP_LISTINGS_ITEMS) {
    return null;
  }

  return (
    <Container
      sx={{
        bottom: isLaptopDown ? "1.5rem" : "initial",
        left: isLaptopDown ? "0.5rem" : "initial",
        top: isLaptopDown ? "initial" : "0.5rem",
        right: isLaptopDown ? "initial" : "0.5rem",
      }}
    >
      <Typography variant="body2" fontWeight={500}>
        {MAX_WIDGETS_FIND_MAP_LISTINGS_ITEMS} of{" "}
        {textFormatter.number(totalItems)} results
      </Typography>
    </Container>
  );
};
